import React, { FunctionComponent } from 'react';
import { THeroSectionCarouselIndicatorProps } from './index.types';

const HeroSectionCarouselIndicator: FunctionComponent<THeroSectionCarouselIndicatorProps> = ({
  isSelected = false,
  index,
  baseClassName = 'controls__dots__item',
}) => {
  const className = isSelected ? baseClassName + ' ' + baseClassName + '--selected' : baseClassName;

  return <li className={className} value={index} />;
};

export default HeroSectionCarouselIndicator;
